/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_CustomizedInputs */

const en_disp_customized = /** @type {(inputs: Disp_CustomizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`changed`)
};

const de_disp_customized = /** @type {(inputs: Disp_CustomizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geändert`)
};

/**
* | output |
* | --- |
* | "changed" |
*
* @param {Disp_CustomizedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_customized = /** @type {((inputs?: Disp_CustomizedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_CustomizedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_customized(inputs)
	return en_disp_customized(inputs)
});